import { CoveragePlan } from 'all-in-one-shared-api';

export function shouldShowDescription(plan: CoveragePlan): boolean {
  return plan != CoveragePlan.MATERNITY && plan != CoveragePlan.EMERGENCY_ASSISTANCE;
}

export function shouldShowDisclaimer(plan: CoveragePlan): boolean {
  return plan == CoveragePlan.OUTPATIENT;
}

export const getDeductibleValue = (plan: CoveragePlan, deductible: number) => {
  if (plan == CoveragePlan.SUPP_MAJOR_MEDICAL || deductible > 0) {
    return `HKD ${deductible.toLocaleString()}`;
  }
  return null;
};
